import React, { useState, useEffect } from "react";
import "../../../styles/desktop/chamados.css";
import Acao from "./acao/acao";
import updateChamadoSolution from "../../../API/server/updateSolucaoChamado";
import updateRegistrosEChamados from "../../../API/node-red/updateRegistrosEChamados";

export default function Chamados({ evento, onClose, getData, chamados, eventos }) {
    const [showAcao, setShowAcao] = useState(false);
    const [chamadoDetalhes, setChamadoDetalhes] = useState(null);
    const [loading, setLoading] = useState(true);
    const [solucao, setSolucao] = useState("");
    const [registrosAssociados, setRegistrosAssociados] = useState([]);

    useEffect(() => {
        const buscarChamado = () => {
            try {
                if (!chamados || !Array.isArray(chamados) || chamados.length === 0) {
                    console.error("Array de chamados inválido ou vazio:", chamados);
                    setRegistrosAssociados([evento]);
                    setChamadoDetalhes({
                        chamado: null,
                        registros: [evento]
                    });
                    setLoading(false);
                    return;
                }

                // Encontra o chamado correspondente ao evento atual
                const chamado = chamados.find(c => {
                    const registroInicial = c.id_registro_inicial?.toString();
                    const registroFinal = c.id_registro_final?.toString();
                    const eventoId = evento.id.toString();
                    
                    return registroInicial === eventoId || registroFinal === eventoId;
                });
                
                if (chamado) {
                    console.log("Chamado encontrado:", chamado);
                    
                    // Inicializa a lista de registros com o evento atual
                    const registros = [evento];
                    
                    // Busca o registro inicial (se existir e for diferente do evento atual)
                    if (chamado.id_registro_inicial && chamado.id_registro_inicial.toString() !== evento.id.toString()) {
                        // Busca nos eventos disponíveis
                        if (eventos && Array.isArray(eventos)) {
                            const eventoInicial = eventos.find(e => e.id.toString() === chamado.id_registro_inicial.toString());
                            
                            if (eventoInicial) {
                                // Se encontrado, adiciona ao início da lista
                                registros.unshift(eventoInicial);
                            } else {
                                // Cria um placeholder se não encontrado
                                const registroInicialPlaceholder = {
                                    id: chamado.id_registro_inicial,
                                    tipo: "Sem informação",
                                    nome: "Sem informação",
                                    ip: "Sem informação",
                                    descricao: "Registro inicial do chamado",
                                    data: "Sem informação",
                                    hora: "Sem informação"
                                };
                                registros.unshift(registroInicialPlaceholder);
                            }
                        }
                    }
                    
                    // Busca o registro final (se existir, for diferente do evento atual e do inicial)
                    if (chamado.id_registro_final && 
                        chamado.id_registro_final.toString() !== evento.id.toString() && 
                        chamado.id_registro_final.toString() !== chamado.id_registro_inicial?.toString()) {
                        
                        // Busca nos eventos disponíveis
                        if (eventos && Array.isArray(eventos)) {
                            const eventoFinal = eventos.find(e => e.id.toString() === chamado.id_registro_final.toString());
                            
                            if (eventoFinal) {
                                // Se encontrado, adiciona ao final da lista
                                registros.push(eventoFinal);
                            } else {
                                // Cria um placeholder se não encontrado
                                const registroFinalPlaceholder = {
                                    id: chamado.id_registro_final,
                                    tipo: "Sem informação",
                                    nome: "Sem informação",
                                    ip: "Sem informação",
                                    descricao: "Registro final do chamado",
                                    data: "Sem informação",
                                    hora: "Sem informação"
                                };
                                registros.push(registroFinalPlaceholder);
                            }
                        }
                    }
                    
                    console.log("Registros associados:", registros);
                    
                    // Atualiza o estado com os registros encontrados
                    setRegistrosAssociados(registros);
                    setChamadoDetalhes({
                        chamado,
                        registros
                    });
                } else {
                    console.log("Nenhum chamado encontrado para o evento:", evento.id);
                    // Se não encontrar chamado, cria um objeto padrão apenas com o evento atual
                    setRegistrosAssociados([evento]);
                    setChamadoDetalhes({
                        chamado: null,
                        registros: [evento]
                    });
                }
            } catch (error) {
                console.error("Erro ao buscar detalhes do chamado:", error);
                setRegistrosAssociados([evento]);
                setChamadoDetalhes({
                    chamado: null,
                    registros: [evento]
                });
            } finally {
                setLoading(false);
            }
        };

        buscarChamado();
    }, [evento, chamados, eventos]);

    const handleRealizarAcao = () => {
        setShowAcao(true);
    };

    const setStatusMessage = () => {
        if (!chamadoDetalhes || !chamadoDetalhes.chamado) {
            return "Ocorrência";
        }
        
        let statusLabel;

        if (chamadoDetalhes.chamado.solucao) {
            statusLabel = "Concluído";
        } else if (chamadoDetalhes.chamado.status === "aberto") {
            statusLabel = "Pendente";
        } else if (chamadoDetalhes.chamado.status === "em andamento") {
            statusLabel = "Solicitação enviada para o responsável";
        } else {
            statusLabel = "Concluído pendente";
        }
        return statusLabel;
    };

    const handleSalvarSolucao = async () => {
        if (solucao) {
            // Ativar indicador de carregamento no componente pai
            getData(true); // Passando true para indicar que está carregando
            
            try {
                if (!chamadoDetalhes || !chamadoDetalhes.chamado || !chamadoDetalhes.chamado.id) {
                    throw new Error("Detalhes do chamado não disponíveis");
                }
                
                // Atualiza o status e salva a solução no backend
                const response = await updateChamadoSolution(chamadoDetalhes.chamado.id, solucao);
    
                if (response?.chamado) {
                    // 2. Atualizar registros e chamados no Node-RED
                    await updateRegistrosEChamados();
                    
                    // 3. Atualizar estado local
                    const atualizado = {
                        ...chamadoDetalhes,
                        chamado: {
                            ...chamadoDetalhes.chamado,
                            status: "Concluído",
                            solucao: response.chamado.solucao,
                        },
                    };
                    setChamadoDetalhes(atualizado);
                    
                    // 4. Atualizar os dados no componente pai
                    await getData(); // Esperar atualização completa
                    
                    alert("Solução salva com sucesso!");
                } else {
                    const errorMsg = response?.error || "Erro desconhecido";
                    alert("Erro ao salvar a solução: " + errorMsg);
                    getData(false); // Desativar carregamento em caso de erro
                }
            } catch (error) {
                console.error("Erro ao salvar solução:", error);
                alert("Erro ao salvar a solução: " + (error.message || "Erro desconhecido"));
                getData(false); // Desativar carregamento em caso de erro
            }
        } else {
            alert("Por favor, selecione uma solução antes de salvar.");
        }
    };

    const renderBtnOptions = () => {
        if (!chamadoDetalhes || !chamadoDetalhes.chamado) {
            return (
                <div className="buttonOpçoesChamados">
                    <button className="btnChamados" onClick={handleRealizarAcao}>
                        Realizar ação
                    </button>
                    <button id="btnAcao-voltar" className="btnChamados" onClick={onClose}>
                        Deixar para depois
                    </button>
                </div>
            );
        }
        
        if (chamadoDetalhes.chamado.solucao) {
            return (
                <button id="btnAcao-acao" className="btnChamados" onClick={onClose}>
                    Voltar
                </button>
            );
        } else if (chamadoDetalhes.chamado.status === "concluído") {
            return (
                <div className="buttonOpçoesChamados">
                    <button className="btnChamados" onClick={handleSalvarSolucao}>
                        Finalizar Chamado
                    </button>
                    <button id="btnAcao-voltar" className="btnChamados" onClick={onClose}>
                        Deixar para depois
                    </button>
                </div>
            );
        } else if (chamadoDetalhes.chamado.status === "em andamento") {
            return (
                <div className="buttonOpçoesChamados">
                    <button id="btnAcao-acao" className="btnChamados" onClick={onClose}>
                        Voltar
                    </button>
                </div>
            );
        } else {
            return (
                <div className="buttonOpçoesChamados">
                    <button className="btnChamados" onClick={handleRealizarAcao}>
                        Realizar ação
                    </button>
                    <button id="btnAcao-voltar" className="btnChamados" onClick={onClose}>
                        Deixar para depois
                    </button>
                </div>
            );
        }
    };

    return (
        <div className="contentChamado">
            {loading ? (
                <p>Carregando detalhes do chamado...</p>
            ) : !showAcao ? (
                <>
                    <div className="headerChamado">
                        <div className="detalhesHeader">
                            <h3>Detalhes do Chamado</h3>
                        </div>
                        {chamadoDetalhes && (
                            <div className="detalhesEventosChamados">
                                {chamadoDetalhes.registros.map((registro, index) => (
                                    <div key={index} className="registroItem">
                                        <p><strong>Registro ID:</strong> {registro.id}</p>
                                        <p><strong>Dispositivo:</strong> {registro.tipo} - {registro.nome}</p>
                                        <p><strong>IP Controlador:</strong> {registro.ip}</p>
                                        <p><strong>Descrição:</strong> {registro.descricao}</p>
                                        <p><strong>Data:</strong> {registro.data}</p>
                                        <p><strong>Hora:</strong> {registro.hora}</p>
                                        {index < chamadoDetalhes.registros.length - 1 && (
                                            <hr />
                                        )}
                                    </div>
                                ))}
                                <p>
                                    <strong>Status:</strong>{" "}
                                    {setStatusMessage()}
                                </p>
                                {chamadoDetalhes?.chamado?.solucao && (
                                    <p>
                                        <strong>Solução:</strong> {chamadoDetalhes.chamado.solucao}
                                    </p>
                                )}
                                {chamadoDetalhes?.chamado?.nome_user_abertura && (
                                    <p>
                                        <strong>Usuário que reportou o chamado:</strong> {chamadoDetalhes.chamado.nome_user_abertura || "chatbot"}
                                    </p>
                                )}
                                {chamadoDetalhes?.chamado?.nome_user_final && (
                                    <p>
                                        <strong>Usuário que finalizou o chamado:</strong> {chamadoDetalhes.chamado.nome_user_final}
                                    </p>
                                )}
                                
                                {chamadoDetalhes?.chamado &&
                                    !chamadoDetalhes.chamado.solucao &&
                                    chamadoDetalhes.chamado.status === "concluído" && (
                                        <div className="solucaoSection">
                                            <label htmlFor="solucaoSelect">Como foi solucionado?</label>
                                            <select
                                                id="solucaoSelect"
                                                value={solucao}
                                                onChange={(e) => setSolucao(e.target.value)}
                                            >
                                                <option value="" disabled>Selecione...</option>
                                                <option value="Atendimento do Chamado">Atendimento do Chamado</option>
                                                <option value="Verificação Interna">Verificação Interna</option>
                                                <option value="Voltou Sozinho">Voltou Sozinho</option>
                                            </select>
                                        </div>
                                    )}
                            </div>
                        )}
                    </div>
                    {renderBtnOptions()}
                </>
            ) : (
                <Acao 
                    onClose={() => setShowAcao(false)} 
                    updateRegistros={getData}
                    fecharPai={onClose}
                    chamadoDetalhes={chamadoDetalhes} 
                />
            )}
        </div>
    );
}